// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__28FJN","search":"Settings_search__2H0Kh","filter":"Settings_filter__38WMD"};